'use strict';

var val = $('.open-in-new-tab').val();
$('.mosaic-component .product-tile-image-link').on('click', function () {
    var url = $(this).attr('href');
    if (val !== 'new-tab') {
        window.open(url, '_self'); // Open in the same tab
    } else {
        window.open(url);
    }

    return false;
});
